import { IMAGE_SERVER } from "../../../../config"
import { StepOption } from "../../../../types/wizard"

export default function ImageSliderSummary({ content }: { content: StepOption }) {
  return (
    <>
      <div className="flex items-center justify-center border border-dashed border-x-0 py-2 my-2">
        <img src={content?.image?.url ? `${IMAGE_SERVER}${content?.image?.url}` : "./ImageNotAvailable.jpeg"} className="w-36" alt={content?.name} />
        <div className="flex flex-col justify-center items-center">
          <h2 className="text-sm font-bold my-1">{content?.name}</h2>
          <p className="w-full text-xs">{content?.longName}</p>
        </div>
      </div>
      <h1 className="text-sm overflow-hidden text-ellipsis">{content?.longDescription}</h1>
    </>
  )
}
